import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CommonProviders, ThemeProvider } from '@/src/contexts';
import { NetworkBanner, TributeFooter } from '@/src/ui-components';

export function RootLayout() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <CommonProviders>
        <NetworkBanner />
        <Outlet />
        <TributeFooter />
        <Toaster richColors position="top-right" />
      </CommonProviders>
    </ThemeProvider>
  );
}
